import store from "../../store/index";
import {Animal} from "../../pages/AppPages/Animals/animal";
import {Municipality} from "@/pages/AppPages/Catalogs/Municipality/municipality";
import api from "@/api";

class _Action {
    constructor(param, callback) {
        this.name = param.name;
        this.icon = param.icon;
        this.class = param.class;
        this.variant = param.variant;
        this.title = param.title;
        this.showTitle = param.showTitle;
        this.emittedEvent = param.emittedEvent;
        this.dropdownList = param.dropdownList;
        this.callback = callback;
        this.available = param.hasOwnProperty('available') ?
            param.available : true
    }

    static callbackObject(objectClass, row) {
        const callbackObject = new objectClass();
        if (row && typeof callbackObject['applyData'] === 'function') {
            callbackObject.applyData(row);
        }
        return callbackObject;
    }
}

class _AvailableAction extends _Action {
    constructor(param, callback, availabilityCallback) {
        super(param, callback);
        this.availabilityCallback = availabilityCallback
    }

}

// class _ObjectAction extends _AvailableAction {
//     constructor(param, callback, availabilityCallback, objectCallback) {
//         super(param, callback, availabilityCallback);
//         this.objectCallback = objectCallback;
//         this.availabilityCallback = availabilityCallback
//     }
// }

const actions = {
    setColVisibility: function (callback, available = true) {
        return new Action({
            name: 'visibility',
            icon: 'eye-slash',
            class: 'btn-secondary',
            title: 'Скрыть/показать колонки',
            showTitle: false,
            emittedEvent: 'on-column-visibility-changed',
            available: true
        }, callback);
    },
    downloadXlsx: function (callback, available = true, title = 'Выгрузить в Excel') {
        return new Action({
            name: 'xlsx',
            icon: 'file-earmark-excel',
            class: 'btn-info',
            title: title,
            showTitle: false,
            emittedEvent: 'on-xlsx',
            available: true
        }, callback);
    },
    view: function (callback, available = true) {
        return new Action({
            name: 'view',
            icon: 'eye',
            class: 'btn-outline-secondary',
            title: 'Просмотр',
            showTitle: false,
            emittedEvent: 'on-view',
            available: available
        }, callback);
    },
    create: function (callback, available = true) {
        return new Action({
            name: 'create',
            icon: 'plus',
            class: 'btn-primary',
            title: 'Добавить',
            showTitle: false,
            emittedEvent: 'on-create',
            available: available
        }, callback);
    },
    edit: function (callback, available = true) {
        return new Action({
            name: 'edit',
            icon: 'pencil',
            class: 'btn-outline-primary',
            title: 'Редактировать',
            showTitle: false,
            emittedEvent: 'on-edit',
            handler: 'onEdit',
            available: available
        }, callback);
    },
    delete: function (callback, available = true) {
        return new Action({
            name: 'delete',
            icon: 'trash',
            class: 'btn-outline-danger',
            title: 'Удалить',
            showTitle: false,
            emittedEvent: 'on-delete',
            handler: 'onDelete',
            available: available
        }, callback)

    },
    objectDelete: function (objectClass) {
        return new AvailableAction({ title: 'Удалить', icon: 'trash', emittedEvent: 'on-delete' }, (id, row) => {
            const object = new objectClass();
            object.applyData(row);
            return object
        }, (row) => {
            const object = new objectClass();
            object.applyData(row);
            return store.getters.ability.can('destroy', object);
        })
    },
};


export const Action = _Action;
export const AvailableAction = _AvailableAction;
export default actions;